/** @jsxImportSource @emotion/react */
import {
  DialogTitle,
  DialogContent,
  DialogFooter,
} from '../../../../components/Dialog';
import {Dialog} from '@reach/dialog';
import Img from './ResetImg.svg';
import Button, {ButtonGroup} from '../../../../components/Button';
import React from 'react';

type DeleteDialogProps = {
  onCancel?: () => void;
  onConfirm?: () => void;
  isOpen?: boolean;
  text?: React.ReactNode;
  title?: React.ReactNode;
};
export default function ResetDialog(props: DeleteDialogProps) {
  const {text, isOpen, onCancel, onConfirm, title} = props;

  return (
    <Dialog isOpen={isOpen} className={'reset-dialog'} aria-label="reset-dialog">
      <DialogTitle
        title={title || '全部重設'}
        onClose={onCancel}
        showCloseButton
      />
      <DialogContent>
        <p css={{marginTop: 16, fontSize: 15, lineHeight: 2}}>
          {text ? (
            text
          ) : (
            <span>
              點選確定重置後，您所建立的資料將全數清除
              <br />
              且不可復原，請問依舊要重置嗎?
            </span>
          )}
        </p>
        <img
          alt="resetImg"
          src={Img}
          css={{marginTop: 15, marginBottom: 40, marginRight: 75}}
        />
      </DialogContent>
      <DialogFooter>
        <ButtonGroup>
          <Button
            variant={'primary'}
            onClick={onConfirm}
            className={'confirm-btn'}
            data-test-id={'confirm-btn'}
            aria-label={'confirm-btn'}
          >
            確定
          </Button>
          <Button
            variant={'cta'}
            onClick={onCancel}
            className={'cancel-btn'}
            data-test-id={'cancel-btn'}
            aria-label={'cancel-btn'}
          >
            取消
          </Button>
        </ButtonGroup>
      </DialogFooter>
    </Dialog>
  );
}
